import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  get_driver_detail,
  get_order_detail,
  get_vendor_detail,
} from "../../utils/api";
import {
  Box,
  Button,
  Card,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import CustomButton from "../../components/ButtonComp";
import { BiArrowBack, BiDownload } from "react-icons/bi";
import DisplayData from "../../components/DisplayData";
import Loader from "../../components/Loader";
import ImageModal from "../../components/ImageModal";
import { baseUrl, formatCurrency } from "../../utils/utils";
import { toast } from "react-toastify";
import CustomDataCard from "../../components/CustomDataCard";
import { get_vehicle_list } from "../../redux/vehiclSlice";
import store from "../../redux/store";
import { useSelector, useDispatch } from "react-redux";
import { get_driver_list } from "../../redux/driverSlice";
import { get_dp_list } from "../../redux/dplistSlice";
import { get_dp_vehicle_list, get_vehicle_driver_list, get_all_drivers } from "../../redux/orderSlice";

const OrderDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { orderid, type, returnTo, returnType } = location.state || {};

console.log(orderid, "order id");
console.log(type, "type");
console.log(returnTo, "return to");
console.log(returnType, "return type");

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const {
    onOpen: onOpenAsign,
    onClose: onCloseAsign,
    isOpen: isOpenAsign,
  } = useDisclosure();
  const [url, setUrl] = useState("");
  const [settingData, setSettingData] = useState({});
  
  // Redux selectors
  const { 
    dp_vehicle_list, 
    vehicle_driver_list, 
    all_drivers,
    vehicle_loading, 
    driver_loading 
  } = useSelector((state) => state.orders);
  const { dp_list } = useSelector((state) => state.dplist);
  const { driver_list } = useSelector((state) => state.drivers);
  const { vehicle_list } = useSelector((state) => state.vehicles);
  
  const user = JSON.parse(localStorage.getItem("authToken1"));
  const [udpateAsingData, setUdpateAsingData] = useState({});

  useEffect(() => {
    if (udpateAsingData.dplist) {
      console.log("Fetching vehicles for DP:", udpateAsingData.dplist);
      dispatch(get_dp_vehicle_list(udpateAsingData.dplist));
      // Reset vehicle and driver when DP changes
      setUdpateAsingData(prev => ({
        ...prev,
        vehicle: "",
        driver: ""
      }));
    }
  }, [udpateAsingData.dplist, dispatch]);

  useEffect(() => {
    if (udpateAsingData.vehicle) {
      console.log("Fetching drivers for vehicle:", udpateAsingData.vehicle);
      dispatch(get_vehicle_driver_list(udpateAsingData.vehicle));
      // Reset driver when vehicle changes
      setUdpateAsingData(prev => ({
        ...prev,
        driver: ""
      }));
    }
  }, [udpateAsingData.vehicle, dispatch]);

  useEffect(() => {
    store.dispatch(get_vehicle_list());
    store.dispatch(get_driver_list());
    store.dispatch(get_dp_list({ page: 1, rows: 100, }));
    dispatch(get_all_drivers());
  }, [dispatch]);

  console.log("DP List:", dp_list);
  console.log("Vehicle List:", dp_vehicle_list);
  console.log("All Vehicle List:", vehicle_list);
  console.log("Driver List:", vehicle_driver_list);
  console.log("All Drivers:", all_drivers);
  console.log("Driver List from redux:", driver_list);

  const fetchOrderDetails = async () => {
    try {
      get_order_detail(orderid, setLoading).then((el) => {
        if (el.success) {
          setData(el.reponselist);
          setSettingData({
            ...settingData,
            credit_days: el.reponselist.credit_days,
            credit_limit: el.reponselist.credit_limit,
          });
        } else {
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const update_order_status = async (status) => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("status", status);
      body.append("id", location.state);
      body.append("action", "update_order");
      const response = await fetch(baseUrl + "orders.php", {
        method: "POST",
        body: body,
      });
      const res = await response.json();

      if (res.success) {
        toast.success(res.message || "Order status updated successfully");
        fetchOrderDetails();
      } else {
        toast.error(res.message || "Order status update failed");
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while updating status");
    } finally {
      setLoading(false);
    }
  };

  // Convert customer data to card format
  const createCustomerCardData = (customer) => [
    {
      key: "Product Name",
      value: customer.product_name,
      valueWeight: "semibold",
    },
    { key: "Type", value: customer.type, valueWeight: "medium" },
    { key: "Quantity", value: customer.count, valueWeight: "medium" },
    {
      key: "Empties Received",
      value: customer.returnclinder,
    },  
    {
      key: "Price",
      value: formatCurrency(customer.price),
      valueWeight: "medium",
    },
    {
      key: "Gst Amount",
      value: formatCurrency(customer.gst_amount),
      valueWeight: "medium",
    },
    {
      key: "Security Deposit",
      value: formatCurrency(Number(customer.security_deposit)),
      valueWeight: "medium",
    },
    {
      key: "Total Amount",
      value: formatCurrency(customer.amount),
      valueWeight: "medium",
    },
  ];

  const validateAsign = () => {
    const error = {};
    if (!udpateAsingData?.dplist) {
      error.dplist_error = "Please select delivery partner";
    }
    if (!udpateAsingData?.vehicle) {
      error.vehicle_error = "Please select vehicle";
    }
    if (!udpateAsingData?.driver) {
      error.driver_error = "Please select driver";
    }
    if (!udpateAsingData?.estimated_delivery_date) {
      error.estimated_delivery_date_error = "Please select estimated delivery date";
    }
    return error;
  };

  const HandleAsign = async () => {
    const error = validateAsign();
    if (Object.keys(error).length == 0) {
      setLoading(true);
      const body = new FormData();
      body.append("action", "assign_order");
      body.append("id", data.orderid);
      body.append("driver_id", udpateAsingData.driver);
      body.append("dpid", udpateAsingData.dplist);
      body.append("vehicle_id", udpateAsingData.vehicle);
      body.append("delivery_estimate", udpateAsingData.estimated_delivery_date);
      body.append("modified_by", user?.id);
      
      const response = await fetch(baseUrl + "orders.php", {
        method: "POST",
        body: body,
      });
      const res = await response.json();

      if (res.success) {
        toast.success(res.message || "Order assigned successfully");
        fetchOrderDetails();
        setUdpateAsingData({});
        onCloseAsign();
      } else {
        toast.error(res.message || "Order assignment failed");
      }
    } else {
      setUdpateAsingData({ ...udpateAsingData, ...error });
    }
    setLoading(false);
  };

  const downloadPDF = async (name, pdf_url) => {
    try {
      const response = await fetch(pdf_url, { method: "GET" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the PDF", error);
    }
  };

  // Handle back navigation with type preservation
  const handleBack = () => {
    if (returnTo && returnType) {
      // Navigate back to the orders page with the preserved type
      navigate(returnTo, { 
        state: { returnType } 
      });
    } else {
      // Fallback to browser back
      navigate(-1);
    }
  };

  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
      >
        <Heading fontSize={"xl"}>Order Details</Heading>
        <Flex alignItems={"center"} gap={3}>
          <CustomButton
            icon={<BiArrowBack color="#fff" />}
            title={"Back"}
            height={"30px"}
            b_color={"#000"}
            onClick={handleBack}
          />
        </Flex>
      </Card>
      
      {loading ? (
        <Card p={5} justify={"center"} alignItems={"center"}>
          <Loader />
        </Card>
      ) : (
        <Stack>
          <Card paddingInline={5} paddingBlock={2}>
            {data?.orderstatus == 1 || (
              <Flex
                direction={["column", "row"]}
                align={["stretch", "center"]}
                gap={2}
                mb={4}
                w="full"
              >
                <Text flexShrink={0} fontWeight="semibold" minW="110px">
                  Order Status
                </Text>
                <Select
                  size="md"
                  w={["100%", "100%", "300px"]}
                  value={data?.orderstatus}
                  onChange={(e) => update_order_status(e.target.value)}
                >
                  <option disabled={data?.orderstatus > "1"} value="1">
                    Order Received
                  </option>
                  <option
                    disabled={data?.orderstatus > "2" || data?.orderstatus !== "1"}
                    value="2"
                  >
                    Order Initiated
                  </option>
                  <option
                    disabled={data?.orderstatus > "3" || data?.orderstatus !== "2"}
                    value="3"
                  >
                    Order Dispatched
                  </option>
                  <option
                    disabled={
                      data?.orderstatus > "4" ||
                      (data?.orderstatus !== "3" && data?.orderstatus !== "4")
                    }
                    value="4"
                  >
                    Order Delivered
                  </option>
                </Select>
              </Flex>
            )}
<DisplayData
  title={"Order ID"}
  v_color={"#f37022"}
  fw={"bold"}
  value={data.orderid || "NA"}
/>

<DisplayData
  title={"Customer Name"}
  value={data.customer_name || "NA"}
  fs={"16px"}
  v_color={"#169e49"}
  fw={"bold"}
/>

<DisplayData title={"Mobile Number"} value={data.mobile || "NA"} />
<DisplayData title={"Email ID"} value={data.email || "NA"} />

<DisplayData
  title={"Total Amount"}
  value={formatCurrency(data.totalamount || 0)}
/>

<DisplayData
  title={"Security Deposit"}
  value={formatCurrency(data.total_security_deposit) || 0}
/>

<DisplayData
  title={"Shipping Address"}
  value={data.shipping_address || "NA"}
/>

<DisplayData title={"Payment Mode"} value={data.paymentmode || "NA"} />

{data.paymentmode === "PO" && (
  <DisplayData title={"PO Number"} value={data.ponum || "NA"} />
)}

<DisplayData title={"Date Time"} value={data.datetime || "NA"} />
<DisplayData title={"Delivery Partner Name"} value={data.delivery_partner_name || "NA"} />
<DisplayData title={"Driver Name"} value={data.driver_name || "NA"} />
{type === "6" ? (
  <></>
):(
<>

<DisplayData title={"Schedule date"} value={data.scheduledate || "NA"} />
<DisplayData title={"Schedule time"} value={data.scheduletime || "NA"} /> 

</>
)}

{type !== "1" ?(
<>
<DisplayData
    title={"Dispatched date & time"}
    value={new Date(data.assign_datetime).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}
  />
</>
):(<>
</>)}     
{data.assign_datetime && data.assign_datetime !== "0000-00-00 00:00:00" && (
  <DisplayData
    title={"Initiated date & time"}
    value={new Date(data.assign_datetime).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}
  />
)}

{type === "6" && Array.isArray(data.reschecdule_orders) && data.reschecdule_orders.length > 0 && (
  <>
    {data.reschecdule_orders.map((item, index) => (
      <div key={item.id || index}>
        <DisplayData 
          title={`Reschedule notes ${data.reschecdule_orders.length > 1 ? index + 1 : ''}`} 
          value={item.reschedule_notes || "NA"} 
        />
        <DisplayData 
          title={`Reschedule date ${data.reschecdule_orders.length > 1 ? index + 1 : ''}`} 
          value={item.rescheduledate || "NA"} 
        />
        <DisplayData 
          title={`Reschedule time ${data.reschecdule_orders.length > 1 ? index + 1 : ''}`} 
          value={item.rescheduletime || "NA"} 
        />
        {item.reschedule_reason && (
          <DisplayData 
            title={`Reschedule reason ${data.reschecdule_orders.length > 1 ? index + 1 : ''}`} 
            value={item.reschedule_reason || "NA"} 
          />
        )}
      </div>
    ))}
  </>
)}


{data.deliver_datetime && data.deliver_datetime !== "0000-00-00 00:00:00" && (
  <DisplayData
    title={"Deliver date & time"}
    value={new Date(data.deliver_datetime).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}
  />
)}

{type === "5" ? (<>
  {data?.cancel_reason && (
  <DisplayData title={"Cancelled Reason"} value={data?.cancel_reason} />
)}  

{data?.cancel_explaination && (
  <DisplayData title={"Cancelled Explanation"} value={data?.cancel_explaination} />
)}

{data.customer_contact_attempt && (
  <DisplayData title={"Customer contact"} value={data?.customer_contact_attempt} />
)}

</>):(<></>)}



            {data?.orderstatus == 1 && (
              <Flex w={"full"} display={"flex"} justifyContent={"center"}>
                <Button
                  size="sm"
                  variant="outline"
                  colorScheme={"blue"}
                  flexShrink={0}
                  mt={"20px"}
                  onClick={() => onOpenAsign()}
                >
                  Assign Order
                </Button>
              </Flex>
            )}
          </Card>

          {data?.challans?.length > 0 && (
            <>
              <Heading fontSize={"xl"}>Delivery Challan</Heading>
              {data?.challans?.map((val, ind) => (
                <Card key={ind} paddingInline={5} paddingBlock={2}>
                  <DisplayData title={"DC No. "} value={val.dc_no} />
                  <DisplayData title={"DC Date"} value={val.dc_date} />
                  <Button
                    colorScheme="blue"
                    size={"sm"}
                    alignSelf={"center"}
                    onClick={() => downloadPDF(val.dc_no, val.dc_path)}
                  >
                    Download DC
                  </Button>
                </Card>
              ))}
            </>
          )}

          <Heading fontSize={"xl"}>Products</Heading>
          <SimpleGrid minChildWidth="xs" spacing="10px">
            {data?.details?.map((el, i) => (
              <CustomDataCard
                key={el.id}
                data={createCustomerCardData(el)}
                keyWidth="100px"
                keyColor="gray.700"
                keyWeight="medium"
                valueColor="gray.600"
                valueAlign="left"
                shadow="lg"
              />
            ))}
          </SimpleGrid>
        </Stack>
      )}
      
      <ImageModal url={url} onClose={onClose} isOpen={isOpen} />
      
      <Modal isOpen={isOpenAsign} onClose={onCloseAsign} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Assign Driver & Vehicle</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDirection={"column"} gap={"2"} w={"full"}>
              <FormControl display={"flex"} flexDirection={"column"} gap={"2"}>
                
                {/* Delivery Partner Selection */}
                <FormLabel mb={0} fontWeight={"bold"}>
                  Select Delivery Partner
                </FormLabel>
                <Select
                  value={udpateAsingData.dplist || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      dplist: e.target.value,
                      dplist_error: "",
                    })
                  }
                  placeholder="Select Delivery Partner"
                  size={"md"}
                  w={"full"}
                >
                  {dp_list?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Select>
                {udpateAsingData.dplist_error && (
                  <Text color={"red"} fontSize="sm">
                    {udpateAsingData.dplist_error}
                  </Text>
                )}

                {/* Vehicle Selection */}
                <FormLabel mb={0} fontWeight={"bold"}>
                  Select Vehicle
                </FormLabel>
                <Select
                  value={udpateAsingData.vehicle || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      vehicle: e.target.value,
                      vehicle_error: "",
                    })
                  }
                  placeholder="Select Vehicle"
                  size={"md"}
                  w={"full"}
                  disabled={!udpateAsingData.dplist} // Disable until DP is selected
                >
                  {vehicle_loading ? (
                    <option disabled>Loading vehicles...</option>
                  ) : (
                    dp_vehicle_list?.map((item) => (
                      <option key={item.vehicle_id} value={item.vehicle_id}>
                        {item.vehicleno}
                      </option>
                    ))
                  )}
                </Select>
                {vehicle_loading && (
                  <Flex align="center" gap={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm">Loading vehicles...</Text>
                  </Flex>
                )}
                {udpateAsingData.vehicle_error && (
                  <Text color={"red"} fontSize="sm">
                    {udpateAsingData.vehicle_error}
                  </Text>
                )}

                {/* Driver Selection */}
                <FormLabel mb={0} fontWeight={"bold"}>
                  Select Driver
                </FormLabel>
                <Select
                  value={udpateAsingData.driver || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      driver: e.target.value,
                      driver_error: "",
                    })
                  }
                  placeholder="Select Driver"
                  size={"md"}
                  w={"full"}
                  disabled={!udpateAsingData.vehicle} // Disable until vehicle is selected
                >
                  {driver_loading ? (
                    <option disabled>Loading drivers...</option>
                  ) : (
                    vehicle_driver_list?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  )}
                </Select>
                {driver_loading && (
                  <Flex align="center" gap={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm">Loading drivers...</Text>
                  </Flex>
                )}
                {udpateAsingData.driver_error && (
                  <Text color={"red"} fontSize="sm">
                    {udpateAsingData.driver_error}
                  </Text>
                )}

                {/* Estimated Delivery Date */}
                <FormLabel mb={0} fontWeight={"bold"}>
                  Estimated Delivery Date
                </FormLabel>
                <Input
                  value={udpateAsingData.estimated_delivery_date || ""}
                  onChange={(e) =>
                    setUdpateAsingData({
                      ...udpateAsingData,
                      estimated_delivery_date: e.target.value,
                      estimated_delivery_date_error: "",
                    })
                  }
                  type="datetime-local"
                  min={new Date().toISOString().slice(0, 16)}
                  placeholder="Select delivery date and time"
                  size="md"
                  w="full"
                />
                {udpateAsingData.estimated_delivery_date_error && (
                  <Text color={"red"} fontSize="sm">
                    {udpateAsingData.estimated_delivery_date_error}
                  </Text>
                )}
              </FormControl>
            </Flex>
            
            {/* Customer Information */}
            <Flex
              mt={3}
              p={2}
              gap={3}
              flexDirection={"column"}
              bg={"#f8f9fa"}
              w={"full"}
              borderRadius={10}
            >
              <Text fontSize={20} fontWeight={"bold"}>
                Customer Information
              </Text>
              <CustomerDetailList
                title={"Customer Name"}
                value={data.customer_name}
              />
              <CustomerDetailList title={"Phone Number"} value={data.mobile} />
              <CustomerDetailList title={"Email"} value={data.email} />
              <CustomerDetailList
                title={"Shipping Address"}
                value={data.shipping_address}
              />
              <Flex
                p={2}
                bg={"white"}
                borderRadius={10}
                w={"full"}
                flexDirection={"column"}
                gap={3}
              >
                {data?.details?.map((el, i) => (
                  <CustomerDetailList
                    key={i}
                    title={el.product_name}
                    value={`Qty: ${el.count} | ${formatCurrency(el.price)}`}
                    fontWeight=""
                    fontSize={14}
                  />
                ))}
              </Flex>
            </Flex>
          </ModalBody>

          <ModalFooter display={"flex"} w={"full"} gap={2} justifyContent={"center"}>
            <Button colorScheme="green" onClick={HandleAsign} isLoading={loading}>
              Assign Order
            </Button>
            <Button
              colorScheme="red"
              onClick={() => {
                onCloseAsign();
                setUdpateAsingData({});
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

const CustomerDetailList = React.memo(
  ({ title, value, fontWeight = "bold", fontSize = 16 }) => {
    return (
      <Flex w={"full"} justifyContent={"space-between"}>
        <Text fontSize={fontSize} fontWeight={fontWeight}>
          {title} :
        </Text>
        <Text fontSize={fontSize} textAlign={"right"}>
          {value}
        </Text>
      </Flex>
    );
  }
);

export default OrderDetail;